import { BaseProxy } from '@/proxies/BaseProxy'

export class ChangePriority extends BaseProxy {
  constructor ({ parameters = {} } = {}) {
    super({
      endpoint: `changePriority`,
      parameters,
    })
  }
}
